import dynamic from "next/dynamic";
const YoutubeTwoThirdsTextAndAssetComponent = dynamic(()=>import("./youtube-two-thirds-text-and-asset-component"));
import YoutubeTwoThirdsTextAndAssetConfig from "./youtube-two-thirds-text-and-asset-config";
import YoutubeTwoThirdsTextAndAssetAdvancedConfig from "./youtube-two-thirds-text-and-asset-advanced-config";
export default {
    YoutubeTwoThirdsTextAndAssetComponent,
    YoutubeTwoThirdsTextAndAssetConfig,
    YoutubeTwoThirdsTextAndAssetAdvancedConfig
};
